import React, { InputHTMLAttributes } from 'react'
import { TextInput } from '../../../Korbantech/components/Inputs/TextInput'
import { Label } from '../../../Korbantech/components/Label'

export const Inputs = React.forwardRef<HTMLInputElement, Props>(({ label , ...props }, ref) => {

    return (
        <div className='col-span-3'>
            <Label>
                <div className='font-semibold'>{label}</div>
                <TextInput {...props} className="rounded-md bg-gray-100 border-gray-500" />
            </Label>
        </div>
    )
})

interface Props extends InputHTMLAttributes<HTMLInputElement> {
    label?:string
    image?:boolean
}